import { WifiHigh, WifiSlash } from "@phosphor-icons/react";

import { cn } from "../utils/cn";

type ConnectionState = "connecting" | "open" | "closed";

interface ConnectionStatusPillProps {
  state: ConnectionState;
  label: string;
}

export function ConnectionStatusPill({ state, label }: ConnectionStatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold",
        state === "open"
          ? "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100"
          : state === "connecting"
            ? "bg-amber-50 text-amber-700 ring-1 ring-amber-100"
            : "bg-rose-50 text-rose-700 ring-1 ring-rose-100"
      )}
    >
      {state === "open" ? (
        <WifiHigh size={16} aria-hidden />
      ) : state === "connecting" ? (
        <InlineSpinner />
      ) : (
        <WifiSlash size={16} aria-hidden />
      )}
      {label}
    </span>
  );
}

function InlineSpinner() {
  return (
    <span
      className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-amber-300 border-t-amber-700"
      aria-hidden
    />
  );
}
